import React, { useCallback, useRef, useState } from 'react';
import { Dropdown } from '../../dropdown';
import IconButton from '../../button/iconButton';
import CommentDropdown from '../../dropdowns/commentDropdown';
import RecordingComment from '../../comment/recordingComment';
import Emoji from '../../emojiPickerDropdown';
import Tooltip from '../../tooltip';
import { Icon, IconSection } from './styles';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import { EmojiClickData } from 'emoji-picker-react';
import { isMAC } from '../../../helpers/common';

interface CommentToolbarProps {
  handleFileInput: () => void;
  onClickSelectFile?: () => void;
  onEmojiSelect: (emojiData: EmojiClickData) => void;
  isMobile: boolean;
  renderSendButton: () => React.ReactNode;
  recording?: {
    valueContent: string;
    setValueContent: (value: string) => void;
    setLoading: (value: boolean) => void;
    setButtonDisable: (value: boolean) => void;
    onOpenSnapModal: () => void;
    uploadSnapEmbed: (firebaseUrl: string, fileName: string, videoId: string) => void;
  };
}

export const CommentToolbar: React.FC<CommentToolbarProps> = React.memo(
  ({ handleFileInput, onClickSelectFile, onEmojiSelect, isMobile, renderSendButton, recording }) => {
    // state variable
    const [isEmojiDropdownOpen, setIsEmojiDropdownOpen] = useState(false);
    const emojiPickerRef = useRef<HTMLDivElement | null>(null);

    const openEmojiDropdown = useCallback((value: boolean) => {
      setIsEmojiDropdownOpen(value);
    }, []);
    return (
      <IconSection>
        <Dropdown
          modalTitle='Attach File'
          activeClassName='active'
          content={
            <IconButton
              iconName='file-attachment-icon'
              size={ICON_BUTTON_SIZE.MEDIUM}
              variant={ICON_BUTTON_TYPE.TERTIARY}
            />
          }>
          <CommentDropdown onClickUploadFile={handleFileInput} onClickSelectFile={onClickSelectFile} />
        </Dropdown>

        {recording && (
          <RecordingComment
            setLoading={recording.setLoading}
            fieldValue={recording.valueContent}
            setValueContent={recording.setValueContent}
            isCommentModel={true}
            setButtonDisable={recording.setButtonDisable}
            handleOpenModal={recording.onOpenSnapModal}
            uploadSnapEmbed={recording.uploadSnapEmbed}
          />
        )}
        <Icon role='button' ref={emojiPickerRef} onClick={() => openEmojiDropdown(!isEmojiDropdownOpen)}>
          <IconButton
            iconName='updated-emoji-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.TERTIARY}
          />
          {isEmojiDropdownOpen && (
            <Emoji
              isOpenEmoji={isEmojiDropdownOpen}
              onEmojiClick={onEmojiSelect}
              setIsOpenEmoji={setIsEmojiDropdownOpen}
              emojiButtonRef={emojiPickerRef}
            />
          )}
        </Icon>
        {!isMobile ? (
          <Tooltip
            maxWidth={'max-content'}
            title={isMAC() ? 'cmd + return to send comment' : 'ctrl + enter to send comment'}>
            {renderSendButton()}
          </Tooltip>
        ) : (
          renderSendButton()
        )}
      </IconSection>
    );
  }
);
